import { useState } from "@wordpress/element";
import { STATION_BUTTONS } from "../../constants/station-constants";
import { IControl } from "@/components/map-container/types/map-type";
import { DataWeatherStation } from "@/schemas/observation-schema";

import MapIconButton from "@/components/map-container/components/map-icon-button/MapIconButton";

import "./style.scss";

type StationMapButtonsProps = {
	setFilter: (value: keyof DataWeatherStation | undefined) => void;
};
export const StationMapButtons = ({ setFilter }: StationMapButtonsProps) => {
	const [buttonsData, setButtonsData] = useState<IControl[]>(STATION_BUTTONS);

	const handleToggle = (text: string) => {
		setButtonsData((prev) =>
			prev.map((c) => ({
				...c,
				isActive: c.text === text,
			})),
		);

		const findItem = buttonsData.find((item) => item.text === text);

		setFilter(findItem?.value);
	};

	const hasSingleActive =
		buttonsData.filter((item) => item.isActive).length === 1;

	return (
		<div className="station-map-button">
			{buttonsData.map((item) => (
				<MapIconButton
					key={item.text}
					data={item}
					isActive={hasSingleActive ? item.isActive : true}
					handleClick={() => handleToggle(item.text)}
				/>
			))}
		</div>
	);
};

export default StationMapButtons;
